import type { ComparisonBlockView } from "../../../../clients/Purchaser/Compare.ts";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "../../compare-generic.css";
import Button from "../../../DesignSystem/Button.tsx";
import { ChevronRight } from "lucide-react";

export default function TableBlock(params: { block: ComparisonBlockView }) {
    return (
        <div>
            <h1 className="mb-4 flex justify-between text-xl font-bold">
                {params.block.type}
                {params.block.type === "Grouped Line Items" && (
                    <Button href="line-items" icon={<ChevronRight />} iconOnThe="right" className="text-sm" color="white" text="All Line Items" />
                )}
            </h1>
            {params.block.content ? (
                <Markdown remarkPlugins={[remarkGfm]} skipHtml={true}>
                    {params.block.content}
                </Markdown>
            ) : (
                <table className="loading">
                    <thead>
                        <tr>
                            <th>
                                <div />
                            </th>
                            <th>
                                <div />
                            </th>
                            <th>
                                <div />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <div />
                            </td>
                            <td>
                                <div />
                            </td>
                            <td>
                                <div />
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
}
